var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('img',{attrs:{"src":require("@/assets/yklogo2.png"),"alt":""}}),_c('p',[_vm._v("地址：北京市朝阳区金和东路20号院正大中心2号楼19-25层")]),_c('p',[_vm._v("全国免费咨询热线：400-626-0148 ")])])
}]

export { render, staticRenderFns }